import { components } from '@kurtosys/ksys-app-components';
import { IComponentConfiguration } from '@kurtosys/ksys-app-components/dist/models/IComponentConfiguration.js';

const ApplicationEmbed = components.base.ApplicationEmbed.ApplicationEmbed;
const AsOfDate = components.base.AsOfDate.AsOfDate;
const Card = components.base.Card.Card;
const Heading = components.base.Heading.Heading;
const Image = components.base.Image.Image;
const Label = components.base.Label.Label;
const Link = components.base.Link.Link;
const Text = components.base.Text.Text;
const Disclaimers = components.overview.Disclaimers.Disclaimers;

export const LIBRARY_COMPONENTS_CONFIGURATION: IComponentConfiguration = {
	base: {
		grid: {
			components: {
				'base.applicationEmbed': {
					key: 'base.applicationEmbed',
					component: ApplicationEmbed,
				},
				'base.card': {
					key: 'base.card',
					component: Card,
				},
				'base.text': {
					key: 'base.text',
					component: Text,
				},
				'base.asOfDate': {
					key: 'base.asOfDate',
					component: AsOfDate,
				},
				'base.heading': {
					key: 'base.heading',
					component: Heading,
				},
				'base.image': {
					key: 'base.image',
					component: Image,
				},
				'base.label': {
					key: 'base.label',
					component: Label,
				},
				'base.link': {
					key: 'base.link',
					component: Link,
				},
				'overview.disclaimers': {
					key: 'overview.disclaimers',
					component: Disclaimers,
				},
			},
		},
	},
};
